// extracted by mini-css-extract-plugin
export default {"container":"my-account-savings-applied-cart-message__container___32YNm","icon":"my-account-savings-applied-cart-message__icon___3KfN2"};